import script from "./AppointmentListView.vue?vue&type=script&setup=true&lang=js"
export * from "./AppointmentListView.vue?vue&type=script&setup=true&lang=js"

import "./AppointmentListView.vue?vue&type=style&index=0&id=17b0936a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17b0936a"]])

export default __exports__